import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';

export const useIsWidthUp = (breakpoint) => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.up(breakpoint));
};
